export const defaultRoute = '/dashboard/home';

export const onboardingRoutePrefix = '/partner-onboarding/';
export const onboardingAddNewMerchantVenueRoute = '/partner-onboarding/new-venue';
export const onboardingMenuSubmissionRoute = '/partner-onboarding/item-submission';

export const menuEditorRoutePrefix = '/menu-editor/';
export const menuEditorEntrypointRoute = '/menu-editor/my-menu';
export const menuEditorCreateMenuRoute = '/menu-editor/my-menu/create';

export const settingsRoutePrefix = '/settings/';
